import request from '@/utils/request'
import qs from 'qs'

export function queryClients(data) {
    return request({
      url: '/api-admin/client/queryClients',
      method: 'get',
      headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: qs.stringify(data)
    })
  }

export function updateClientRoles(data) {
  return request({
    url: '/api-admin/client/updateClientRoles',
    method: 'post',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: qs.stringify(data)
  })
}

export function updateClient(data) {
  return request({
    url: '/api-admin/client/updateClient',
    method: 'post',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: qs.stringify(data)
  })
}